/**
 * Validate an unknown value to determine if it's a record object.
 *
 * @example key value object is a record
 * ```ts
 * isRecord({ "key": "value" }) // true
 * ```
 * @example array is not a record
 * ```ts
 * isRecord([1, 2, 3]) // false
 * ```
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}
